module.exports = __webpack_public_path__ + "assets/3-rainmakers-hiring-process.3c942ff9.png";